<template>
  <div class="py-4 container-fluid">
    <!-- BELUM MULAI VALUASI -->
    <div class="card" v-if="loaded && !start">
      <div class="card-body">
        <h6>Valuasi Persediaan Belum Dimulai</h6>
        <p class="text-sm">
          Saat dimulai, sistem membuat <b>saldo awal</b> dari stok yang ada sekarang, dengan harga satuan = harga PO terakhir (excl. PPN, IDR).
          Setelah itu setiap barang masuk, barang keluar, dan retur dinilai otomatis dengan metode <b>rata-rata tertimbang (average)</b>, dan barang keluar dijurnal sebagai pemakaian/HPP per proyek.
          Harga saldo awal bisa dikoreksi per barang setelahnya. Langkah ini hanya bisa dilakukan <b>sekali</b>, sebaiknya di awal bulan setelah stock opname.
        </p>
        <argon-button variant="gradient" color="success" size="sm" @click="generate()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Memproses semua barang, mohon tunggu...</span>
          <span v-else>Mulai Valuasi Persediaan</span>
        </argon-button>
      </div>
    </div>

    <div v-if="start">
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-3">
          <div class="card"><div class="card-body p-3">
            <p class="text-xs mb-1 text-uppercase font-weight-bold">Total Nilai Persediaan</p>
            <h5 class="font-weight-bolder mb-0">{{ fmt(totalValue) }}</h5>
            <p class="text-xxs mb-0">Valuasi sejak {{ moment(start).locale('id').format('LLL') }}</p>
          </div></div>
        </div>
        <div class="col-lg-3 col-md-6 mb-3" v-for="(f, key) in flagLabels" :key="key">
          <div class="card" style="cursor: pointer;" @click="search.flag = key; get()">
            <div class="card-body p-3">
              <p class="text-xs mb-1 text-uppercase font-weight-bold">{{ f }}</p>
              <h5 :class="'font-weight-bolder mb-0 '+(flags[key] > 0 ? 'text-danger' : 'text-success')">{{ flags[key] || 0 }}</h5>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body p-3">
          <span class="text-xs font-weight-bold me-2">Per kategori:</span>
          <span class="badge badge-sm bg-gradient-secondary me-1 mb-1" v-for="(c, i) in byCategory" :key="'c'+i">{{ c.category_name || 'Tanpa Kategori' }}: {{ fmt(c.value) }}</span>
        </div>
      </div>

      <div class="card">
        <div class="row">
          <div class="col-lg-3">
            <div class="card-header pb-0"><h6>Nilai Persediaan per Barang</h6></div>
          </div>
          <div class="col-lg-3"><input type="text" class="form-control mt-3" placeholder="Cari kode / nama barang" v-model="search.search" v-on:keyup.enter="get()"></div>
          <div class="col-lg-3">
            <select class="form-select mt-3" v-model="search.category" @change="get()">
              <option value="">Semua Kategori</option>
              <option v-for="(c, i) in categories" :key="'cat'+i" :value="c.category_code">{{ c.category_name }}</option>
            </select>
          </div>
          <div class="col-lg-3">
            <select class="form-select mt-3" v-model="search.flag" @change="get()">
              <option value="">Semua Barang</option>
              <option value="in_stock">Ada Stok</option>
              <option v-for="(f, key) in flagLabels" :key="'f'+key" :value="key">{{ f }}</option>
            </select>
          </div>
        </div>

        <div class="card-body px-0 pt-0 pb-2 mt-3">
          <div class="table-responsive p-0 scroll">
            <table class="table table-striped align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Barang</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Kategori</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Qty</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Harga Rata-rata</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Nilai</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Harga Saldo Awal</th>
                  <th class="text-secondary"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in table.data" :key="i">
                  <td class="text-xs"><span class="font-weight-bold">{{ row.material_code }}</span><br>{{ row.material_name }}</td>
                  <td class="text-xs">{{ row.category_name || '-' }}</td>
                  <td :class="'text-center text-xs '+(Number(row.qty) < 0 ? 'text-danger font-weight-bold' : '')">
                    {{ num(row.qty) }} {{ row.unit }}
                    <span class="text-danger text-xxs" v-if="Number(row.qty) != Number(row.system_qty)"><br>stok sistem: {{ num(row.system_qty) }}</span>
                  </td>
                  <td class="text-end text-xs">{{ fmt(row.avg_cost) }}</td>
                  <td class="text-end text-xs font-weight-bold">{{ fmt(row.value) }}</td>
                  <td class="text-end text-xs">
                    <span v-if="row.opening_qty !== null">
                      {{ fmt(row.opening_cost) }}
                      <span :class="'badge badge-sm ms-1 '+(row.cost_source == 'none' ? 'bg-gradient-danger' : (row.cost_source == 'manual' ? 'bg-gradient-info' : 'bg-gradient-secondary'))">{{ costSourceLabel[row.cost_source] }}</span>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-xs">
                    <i class="fa fa-list-alt" style="cursor: pointer; margin-right: 12px;" title="Kartu stok bernilai" @click="openLedger(row.material_code)"></i>
                    <i class="fas fa-edit" style="cursor: pointer;" title="Koreksi harga saldo awal" @click="editOpening(row)" v-if="row.opening_qty !== null"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
          <div class="float-right">
            <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL KARTU STOK BERNILAI ======= -->
  <div class="container">
    <vue-final-modal v-model="ledgerShow" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Kartu Stok Bernilai {{ ledger.item ? ledger.item.material_code+' - '+ledger.item.material_name : '' }}</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="ledgerShow = false"></i></div>
      </div><hr>
      <div class="modal__content container table-responsive">
        <table class="table table-sm align-items-center">
          <thead><tr>
            <th class="text-xxs text-secondary">Tanggal</th><th class="text-xxs text-secondary">Transaksi</th><th class="text-xxs text-secondary">Ref / WO</th>
            <th class="text-xxs text-secondary text-end">Masuk</th><th class="text-xxs text-secondary text-end">Keluar</th><th class="text-xxs text-secondary text-end">Harga</th>
            <th class="text-xxs text-secondary text-end">Nilai</th><th class="text-xxs text-secondary text-end">Saldo Qty</th><th class="text-xxs text-secondary text-end">Saldo Nilai</th><th class="text-xxs text-secondary text-end">Rata-rata</th>
          </tr></thead>
          <tbody>
            <tr v-for="(l, i) in ledger.ledger" :key="'l'+i">
              <td class="text-xs">{{ moment(l.trx_date).locale('id').format('ll') }}</td>
              <td class="text-xs">{{ sourceLabel[l.source_type] }}</td>
              <td class="text-xs">{{ l.reference }} {{ l.wo_code }}</td>
              <td class="text-xs text-end">{{ Number(l.qty_in) ? num(l.qty_in) : '' }}</td>
              <td class="text-xs text-end">{{ Number(l.qty_out) ? num(l.qty_out) : '' }}</td>
              <td class="text-xs text-end">{{ fmt(l.unit_cost) }}</td>
              <td class="text-xs text-end">{{ Number(l.value_in) ? fmt(l.value_in) : '('+fmt(l.value_out)+')' }}</td>
              <td class="text-xs text-end">{{ num(l.balance_qty) }}</td>
              <td class="text-xs text-end">{{ fmt(l.balance_value) }}</td>
              <td class="text-xs text-end">{{ fmt(l.avg_cost) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccInventoryValue",
  components: { ArgonButton, VueFinalModal, BasePagination },
  data() {
    return {
      moment: moment,
      loaded: false,
      start: null,
      totalValue: 0,
      byCategory: [],
      categories: [],
      flags: {},
      flagLabels: { no_cost: 'Saldo Awal Tanpa Harga', negative: 'Stok Minus', mismatch: 'Selisih vs Stok Sistem' },
      costSourceLabel: { last_po: 'PO terakhir', manual: 'manual', none: 'belum ada harga' },
      sourceLabel: { OPENING: 'Saldo Awal', GR: 'Terima dari PO', IN_OTHER: 'Masuk lain / retur', ISSUE: 'Barang keluar' },
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      search: { search: '', category: '', flag: '' },
      ledgerShow: false,
      ledger: { item: null, ledger: [] },
      onLoading: false,
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    num(value) {
      return Number(value || 0).toLocaleString('id-ID', { maximumFractionDigits: 2 });
    },
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.inventoryValue(Object.assign({ page: context.pagination.page }, context.search))).onSuccess(function(response) {
          let d = response.data.data;
          context.start                 = d.start;
          context.totalValue            = d.totalValue;
          context.byCategory            = d.byCategory;
          context.categories            = d.categories;
          context.flags                 = d.flags;
          context.table.data            = d.data.data;
          context.pagination.page_count = d.data.last_page;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() {
          context.loaded = true;
      })
      .call()
    },
    generate() {
      if (!confirm('Mulai valuasi persediaan sekarang? Saldo awal diambil dari stok saat ini dan langkah ini hanya bisa dilakukan sekali.')) {
        return;
      }
      let context = this;
      context.onLoading = true;
      Api(context, accounting.generateOpening()).onSuccess(function(response) {
          context.notify(response.data.message, 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Gagal memulai valuasi', 'error')
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call();
    },
    editOpening(row) {
      let value = prompt('Harga satuan saldo awal untuk '+row.material_code+' (IDR, excl. PPN):', Number(row.opening_cost));
      if (value === null) {
        return;
      }
      if (isNaN(Number(value)) || Number(value) < 0) {
        return alert('Harga tidak valid');
      }
      let context = this;
      Api(context, accounting.updateOpeningCost({ material_code: row.material_code, unit_cost: Number(value) })).onSuccess(function() {
          context.notify('Harga saldo awal disimpan, nilai & HPP dihitung ulang', 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Gagal menyimpan', 'error')
      })
      .call();
    },
    openLedger(materialCode) {
      let context = this;
      Api(context, accounting.inventoryLedger(materialCode)).onSuccess(function(response) {
          context.ledger     = response.data.data;
          context.ledgerShow = true;
      }).call();
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 4000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1150px;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
